import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

import { pricingBasisLine } from '../lib/pricing-basis';
import type { TicketContextForTradeInvoice } from './trade-invoice-payload';

export function formatMoney(value: number, currency: string | null): string {
  const fixed = value.toFixed(2);
  return currency === null ? fixed : `${fixed} ${currency}`;
}

export function safeNumber(raw: unknown): number {
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (typeof raw === 'string' && raw.trim() !== '') {
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

export function PricingBasis(props: { readonly ticket: TicketContextForTradeInvoice }) {
  return (
    <p className="text-muted-foreground text-sm" data-testid="final-settlement-pricing-basis">
      Pricing basis: {pricingBasisLine(props.ticket)}
    </p>
  );
}

export function OverpaymentAcknowledge(props: {
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly onChange: (checked: boolean) => void;
}) {
  return (
    <label
      className="border-destructive/40 bg-destructive/5 flex items-start gap-2 rounded-md border p-3 text-sm"
      data-testid="final-settlement-overpayment-acknowledge"
    >
      <Checkbox
        checked={props.checked}
        onCheckedChange={(checked) => {
          props.onChange(checked === true);
        }}
        disabled={props.disabled}
      />
      <Label className="leading-tight">
        I acknowledge this Final Settlement nets to an overpayment — a Credit Note will be raised
        separately to refund the difference.
      </Label>
    </label>
  );
}
